import React, { useState } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import AdminAudioCloudTab from "./AdminAudioCloudTab";
import AdminAudioLocalTab from "./AdminAudioLocalTab";

export default function AdminAudioMain() {
    const [tab, setTab] = useState(0);

    return (
        <Box>
            <Typography variant="h6" component="h1" sx={{ mb: 2 }}>
                Audio
            </Typography>

            <Box sx={{ mb: 2, borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                    value={tab}
                    onChange={(_, value) => setTab(value)}
                    variant="fullWidth"
                    aria-label="Audio admin sections"
                    sx={{
                        bgcolor: "action.hover",
                        minHeight: 48,
                        "& .MuiTab-root": {
                            minHeight: 48,
                            textTransform: "none",
                            fontWeight: 600,
                            color: "text.secondary",
                            "&.Mui-selected": {
                                bgcolor: "background.paper",
                                color: "primary.main",
                            },
                        },
                    }}
                >
                    <Tab label="Cloud library" />
                    <Tab label="Local files" />
                </Tabs>
            </Box>

            {tab === 0 && <AdminAudioCloudTab />}
            {tab === 1 && <AdminAudioLocalTab />}
        </Box>
    );
}
